import { Component, Output, EventEmitter, Input } from '@angular/core';
import { CsvService } from 'core/services';
import { TranslateService } from '@ngx-translate/core';
const MAX_BYTES = 2000000;
@Component({
  selector: 'lms-csv-import',
  templateUrl: './csv-import.component.html',
  styleUrls: ['./csv-import.component.scss']
})
export class CsvImportComponent {
  public csvData: any;
  public selectedFile: boolean = false;
  public hasToReEnroll = true;

  @Input() isGroup: boolean = false;
  @Input() isKepler: boolean = false;
  @Input() isMars: boolean = false;
  @Input() isEmailChange: boolean = false;
  @Input() title: string = 'actions.uploadCsvDocument';
  @Input() buttonText: string = 'actions.processFile';
  @Output() onSaveCsvData: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();

  constructor(public csvService: CsvService, public translate: TranslateService) {}

  closeCsvModal() {
    this.closeModal.emit();
    this.selectedFile = false;
    this.csvData = null;
  }
  onGetFile(event: any) {
    const files: File = event[0] ? event[0] : event.target.files[0];

    if (files.size <= MAX_BYTES) {
      this.selectedFile = true;
      this.csvData = files;
    }
  }
  onSaveCsv() {
    if (this.isGroup) {
      this.onSaveCsvData.emit({ csvData: this.csvData, hasToReEnroll: this.hasToReEnroll });
    } else {
      this.onSaveCsvData.emit(this.csvData);
    }
    this.closeCsvModal();
  }
  downloadCsv() {
    const csvToDownload = [
      {
        name: 'Max',
        surname: 'Power',
        email: 'max@power.com',
        phone: '2117029922',
        pid: '012345A',
        comments: '',
        lang: 'en',
        alias: 'MAXI',
        tag1: 'tag1',
        tag2: 'tag2',
        tag3: 'tag3',
        tag4: '',
        tag5: ''
      },
      {
        name: 'Daisy',
        surname: 'Powell',
        email: 'daisy.powell83@pharmacon.com',
        phone: '2887907284',
        pid: '012345B',
        comments: '',
        lang: 'en',
        alias: 'DAI',
        tag1: 'tag1',
        tag2: 'tag2',
        tag3: 'tag3',
        tag4: '',
        tag5: ''
      }
    ];
    this.csvService.dataToCsv(csvToDownload, 'user-import-example', {
      headers: Object.keys(csvToDownload[0]),
      shouldTranslateHeaders: true,
      filename: 'user-import-example'
    });
  }
  downloadCsvForEmail() {
    const csvToDownload = [
      {
        email: 'max@power.com',
        newEmail: 'new.max@power.com'
      },
      {
        email: 'daisy.powell83@pharmacon.com',
        newEmail: 'new.daisy.powell83@pharmacon.com'
      }
    ];
    this.csvService.dataToCsv(csvToDownload, 'user-change-email-example', {
      headers: Object.keys(csvToDownload[0]),
      shouldTranslateHeaders: true,
      filename: 'user-change-email-example'
    });
  }

  downloadCsvForMars() {
    const csvToDownload = [
      {
        name: 'Max',
        surname: 'Power',
        email: 'max@power.com',
        lang: 'en',
        alias: 'MAXI',
        tag1: 'tag1',
        tag2: 'tag2',
        tag3: 'tag3',
        tag4: '',
        tag5: ''
      },
      {
        name: 'Daisy',
        surname: 'Powell',
        email: 'daisy.powell83@pharmacon.com',
        lang: 'en',
        alias: 'DAI',
        tag1: 'tag1',
        tag2: 'tag2',
        tag3: 'tag3',
        tag4: '',
        tag5: ''
      }
    ];
    this.csvService.dataToCsv(csvToDownload, 'mars-import-example', {
      headers: Object.keys(csvToDownload[0]),
      shouldTranslateHeaders: true,
      filename: 'user-import-example'
    });
  }
  deleteFile() {
    this.selectedFile = false;
  }
}
